import { Component, Input, OnInit } from '@angular/core';
import { DataService } from "../services/data.service";
import { HeadsComponent } from '../heads/heads.component';
import { filterPipe } from '../pipe/search/search.pipe';
import { AccountsComponent } from '../accounts/accounts.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { FormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FinancialYearcountComponent } from '../financial-yearcount/financial-yearcount.component';
import { Subject } from 'rxjs';
import { APIService, isGalaxyFoldPhome } from '../api.service';
import { CfgGstLedgersComponent } from '../cfg-gst-ledgers/cfg-gst-ledgers.component';

@Component({
  selector: 'app-recent-vouchers',
  templateUrl: './recent-vouchers.component.html',
  styleUrls: ['./recent-vouchers.component.scss']
})
export class RecentVouchersComponent implements OnInit {

   @Input() accountDates: Subject<{
      fdt: Date,
      tdt: Date,
      selectedFy: String
    }> = new Subject();

  changingValue: Subject<boolean> = new Subject();
  changingHeadValue: Subject<boolean> = new Subject();
  isShowBtn: boolean = false;
  right: any;
  jarvisData: any = [];
  isGalaxyFoldMobile: boolean = isGalaxyFoldPhome;
  isWeb: boolean = true;
  agencyData: any;
  selectedObj: any = {};
  isGSTLedgersConfigured: boolean = false;
  fromDate: any;
  toDate: any;

  constructor(private apiService: APIService, private appService: DataService, public accountsComponent: AccountsComponent, private deviceService: DeviceDetectorService, private modalService: NgbModal) {

    this.appService.favLedgerData.subscribe((value: any) => {
      if (value.fromHome == true) {
        this.tmpLedger.push(value);

        this.favLedger = [];
        this.tmpLedger.forEach((element: any) => {
          if (element.IsFav == true) {
            element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
            this.favLedger.push({
              name: element.LedgerName,
              currentBal: element.OpBal,
              isFav: element.IsFav,
              id: element.id,
              ClosingBal: element.CloBal
            });
          }
        });
      }

      else {
        this.tmpLedger = value;

        this.favLedger = [];
        this.tmpLedger.forEach((element: any) => {
          if (element.IsFav == true) {
            element.CloBal.charAt(0) == "-" ? element.ClosingBal = element.CloBal.substring(1) + ' Cr' : element.ClosingBal = element.CloBal + ' Db';
            this.favLedger.push({
              name: element.LedgerName,
              currentBal: element.OpBal,
              isFav: element.IsFav,
              id: element.LedgerID,
              ClosingBal: element.CloBal
            });
          }
        });
      }
      this.dataSource.data = this.favLedger;
      this.isShowBtn = true
      this.dataSource.filterPredicate = this.createFilter();
    })

  }

  ngOnInit(): void {
    this.favLedger = [];
    this.favLed = true;
    let currDT = new Date();

    this.isWeb = this.apiService.apiCheckWeb();

    this.NameFilter.valueChanges
      .subscribe(
        NameFilter => {
          this.filterValues.Name = NameFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.currentBalFilter.valueChanges
      .subscribe(
        currentBalFilter => {
          this.filterValues.currentBal = currentBalFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.ClosingBalFilter.valueChanges
      .subscribe(
        ClosingBalFilter => {
          this.filterValues.ClosingBal = ClosingBalFilter;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

      var jarvis = this.apiService.getCookie("Jarvis");
      if (jarvis) {
        this.jarvisData = JSON.parse(jarvis);
      }

      this.right = this.apiService.getCookie("J");
      if(this.right){
        this.right = JSON.parse(this.right);
        let ownUserID: number = this.jarvisData[0].UserID;
        this.right = $.grep(this.right, function(o: any){ return o.UserID == ownUserID })[0];
        if(!this.right.Accts && !this.right.AcctsVchrEntry && !this.right.AcctsCfg){
          window.location.href = "main.html#/home";
          return;
        }
    }
   let agencyData = this.apiService.getCookie("M");
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      var PremiumTillDT = this.agencyData[0].PremiumTillDT;
      // if (new Date(PremiumTillDT) < new Date() || !PremiumTillDT || PremiumTillDT == null) {
      //   window.location.href = "main.html#/home";
      //   return;
      // }
      
      if (this.apiService.checkIsPremiumOrTrial() == false){
        if (this.apiService.fn_isLiveURL() == true)
        {
          window.location.href = "https://biziverse.com/main.html#/home";
          return;
        }
        else{
          window.location.href = "main.html#/home";
          return;
        }    
      }
    }
   
    if(this.accountDates) {
      this.accountDates.subscribe(dates => {
        this.fromDate = dates.fdt;
        this.toDate = dates.tdt;
      })
    }

    this.fn_Set_FinancialYear(currDT);
    this.checkGSTLedgersConfiguration();
  }

  favLed: any;
  ledger: any = [];
  favLedger: any = [];
  search: string = '';
  isShowSearch: boolean = false;
  tmpLedger: any = [];
  isMobileView: boolean = false;
  displayedColumns: string[] = ['name', 'currentBal', 'ClosingBal'];
  NameFilter = new FormControl('');
  currentBalFilter = new FormControl('');
  ClosingBalFilter = new FormControl('');
  dataSource = new MatTableDataSource();

  filterValues = {
    Name: '',
    currentBal: '',
    ClosingBal: ''
  };
  modalReference: any;

  removeFav(i: any) {
    this.favLedger.splice(i, 1);
  }


  closeResult: any;

  open(content: any) {
    this.modalReference = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', windowClass: 'my-class', backdrop: 'static', keyboard: false });
    this.modalReference.result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason: any) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    //   this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
    //       this.closeResult = `Closed with: ${result}`;
    //   }, (reason) => {
    //       this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    //   });
  }

  openNewWindowVoucher($event: any){    
    let urlCheck: string = "";
    if (this.apiService.fn_isLiveURL() == true) {
      urlCheck = "/ERP";
    }
    urlCheck += "/voucher"; 
    //Using App
    let target: string = "_blank";
    if(this.isWeb == false){
      target = "_self";
    }
    var win: any = window.open(urlCheck, target, 'height = 600, width = 1250');
    var timer = setInterval(() => {
      if(win != null){
        if (win.isSuccessVoucher) {
          clearInterval(timer);
          this.changingValue.next($event);
          this.changingHeadValue.next($event);
          win.close();
        }
      }

      if (win.closed) {
          clearInterval(timer);
      }
    }, 100);
    //window.open("/voucher", '_blank', 'height = 600, width = 1250');
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  public closeModal($event: any) {
    this.modalReference.close();
    if ($event) {
      this.changingValue.next($event);
      this.changingHeadValue.next($event);
    }
  }


  openLedger(obj: any) {
    //Open ledger side
    if (!this.isMobileView && obj) {
      this.expandView(obj)
    } else {
      this.accountsComponent.isShowRVoucher = false;
      this.appService.updateData(obj);
      if (this.isMobileView) {
        this.accountsComponent.isShowRVoucherMob = true;
      }
    }
  }

  expoanTable(expand: any) {
    this.modalReference = this.modalService.open(expand, { windowClass: "favLedgerClass" });
  }

  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data: any, filter: any): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toLowerCase().indexOf(searchTerms.Name.toLowerCase()) !== -1
        && data.currentBal.toString().toLowerCase().indexOf(searchTerms.currentBal) !== -1
        && data.ClosingBal.toString().toLowerCase().indexOf(searchTerms.ClosingBal) !== -1;
    }
    return filterFunction;
  }

  // checkGSTLedgersConfiguration() - Check if GST Ledgers are configured
  checkGSTLedgersConfiguration() {
    let tmpERP_cfg = this.apiService.getCookie('ERP_Cfg');
    if (tmpERP_cfg) {
      let Cfg_AgnCfg = JSON.parse(tmpERP_cfg);
      if (Cfg_AgnCfg[0].GSTLedgers) {
        let gstLedgerList = JSON.parse(Cfg_AgnCfg[0].GSTLedgers);
        this.isGSTLedgersConfigured = gstLedgerList && gstLedgerList.length > 0;
      }
    }
  }

  // GSTLedgerModal() - Open GST ledger modal
  GSTLedgerModal() {
    const modalRef = this.modalService.open(CfgGstLedgersComponent, { 
      windowClass: "gstSelectModal", 
      backdrop: 'static', 
      keyboard: false 
    });
    
    // Refresh GST Ledgers configuration status after modal closes
    modalRef.result.then(
      (result) => {
        if (result === 'saved') {
          this.checkGSTLedgersConfiguration();
        }
      },
      (reason) => {
        // Modal dismissed
      }
    );
  }

  fn_Set_FinancialYear(ToDT: any) {
    var toDT = new Date(ToDT);
    var fullYear: any;
    var isPrevious = 0;
    if (toDT.getMonth() < 3) {
      fullYear = toDT.getFullYear() - 1
      isPrevious = 1;
    } else {
      fullYear = toDT.getFullYear() + 1
      isPrevious = 0;
    }
    if (isPrevious == 1) {
      this.fromDate = new Date(fullYear + "/04/01");
      this.toDate = new Date(toDT.getFullYear() + "/03/31");
    }
    else if (isPrevious == 0) {
      this.fromDate = new Date(toDT.getFullYear() + "/04/01");
      this.toDate = new Date(fullYear + "/03/31");
    }
  }

  expandView(head: any) {
    let isLive = this.apiService.fn_isLiveURL()
    let target: string = "_blank";
    if(!this.isWeb){
      target = "_self";
    }
    let fromDT = this.fromDate ? new Date(this.fromDate).customFormat("#DD#-#MMM#-#YYYY#") : `01-Apr-${new Date().getFullYear()}`;
    let toDT = this.toDate ? new Date(this.toDate).customFormat("#DD#-#MMM#-#YYYY#") : `31-Mar-${(new Date().getFullYear()) + 1}`;
    let redirectLink  = '';
    if(head.isHead) {
      let headID = head.id;
      redirectLink = (isLive ? '/ERP' : '') + '/HeadRecord?hid=' + encodeURIComponent(headID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT) 
    }
    else {
      let ledgerID = head.id;
      redirectLink = (isLive ? '/ERP' : '') + '/LedgerRecord?lid=' + encodeURIComponent(ledgerID) + '&fromDT=' + encodeURIComponent(fromDT) + '&toDT=' + encodeURIComponent(toDT)
    }
    window.open(redirectLink, target);
    
  }

  redirectToGSTR3B() {
    let target: string = "_blank";
    if(!this.isWeb){
      target = "_self";
    }
    window.open('/ERP/GSTR3B', target);
  }
}
